const features = [
  {
    icon: "ri-building-2-line",
    title: "실제 업무 시뮬레이션",
    description: "전자결재, 예산 기안, 계약서 검토 등 현업과 동일한 워크플로우를 체험합니다. 재무 ERP부터 마케팅 캠페인까지 실무 업무를 수행합니다.",
    tag: "Workflow",
    accent: "#4B6CF7",
    accentBg: "rgba(75,108,247,0.07)",
  },
  {
    icon: "ri-robot-line",
    title: "AI NPC 거래처 협상",
    description: "투자자, 언론사, 유통사, 광고주 등 직무별 AI NPC와 실제 비즈니스 협상을 진행합니다. 협상 결과가 자본금과 명성에 즉시 반영됩니다.",
    tag: "AI Negotiation",
    accent: "#7C3AED",
    accentBg: "rgba(124,58,237,0.07)",
  },
  {
    icon: "ri-file-list-3-line",
    title: "전자결재 워크플로우",
    description: "계약서 기안, 예산 승인, 법적 대응 기안서 등 직무 간 결재 흐름이 연동됩니다. 상위 직무의 승인이 하위 직무 업무에 영향을 미칩니다.",
    tag: "Approval",
    accent: "#059669",
    accentBg: "rgba(5,150,105,0.07)",
  },
  {
    icon: "ri-bar-chart-grouped-line",
    title: "재무 / ERP 시스템",
    description: "자본금, 매출, 비용, 세금 신고까지 통합 관리합니다. 회계 전표처리와 총계정원장 기능으로 실제 기업 재무 구조를 학습합니다.",
    tag: "Finance",
    accent: "#D97706",
    accentBg: "rgba(217,119,6,0.07)",
  },
  {
    icon: "ri-team-line",
    title: "팀 기반 멀티플레이",
    description: "5가지 기업 유형에 걸쳐 전체 16가지 직무 역할 중 각자 역할을 맡아 협업합니다. 재무 결재, 계약 검토, 마케팅 기획이 서로 맞물려 팀 경영 지표에 실시간 반영됩니다.",
    tag: "Team Play",
    accent: "#E11D48",
    accentBg: "rgba(225,29,72,0.07)",
  },
  {
    icon: "ri-dashboard-3-line",
    title: "강사 관리 대시보드",
    description: "강사가 모든 학생 팀의 현황을 실시간 모니터링합니다. 랜덤 이벤트 수동 발송, 팀별 성과 비교, 리스크 관리 기능을 제공합니다.",
    tag: "Admin",
    accent: "#0891B2",
    accentBg: "rgba(8,145,178,0.07)",
  },
];

const PD = "'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, sans-serif";

export default function FeaturesSection() {
  return (
    <section id="features" className="bg-white py-16 md:py-24 lg:py-32" style={{ fontFamily: PD }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 text-[#4B6CF7] text-xs font-medium uppercase tracking-widest mb-4 bg-[#4B6CF7]/[0.07] px-3 py-1.5 rounded-full border border-[#4B6CF7]/15">
            <i className="ri-grid-line text-xs"></i> Platform Features
          </div>
          <h2
            className="text-3xl md:text-4xl font-bold text-[#111111] mb-4 leading-snug"
            style={{ fontFamily: PD }}
          >
            현업 그대로의 경영 경험
          </h2>
          <p className="text-[#888888] text-base max-w-xl mx-auto leading-relaxed">
            실제 문화예술 기업에서 일어나는 모든 업무를 디지털 환경에서 경험합니다.
          </p>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {features.map((feat, i) => (
            <div
              key={i}
              className="group bg-white border border-black/[0.08] rounded-2xl p-6 hover:border-black/[0.14] transition-all duration-300 cursor-default"
            >
              <div className="flex items-start gap-4 mb-4">
                <div
                  className="w-10 h-10 flex items-center justify-center rounded-xl shrink-0 transition-all"
                  style={{ backgroundColor: feat.accentBg, border: `1px solid ${feat.accent}22` }}
                >
                  <i className={`${feat.icon} text-base`} style={{ color: feat.accent }}></i>
                </div>
                <span
                  className="text-[10px] border px-2 py-0.5 rounded-full mt-1.5 uppercase tracking-widest font-medium"
                  style={{
                    color: feat.accent,
                    backgroundColor: feat.accentBg,
                    borderColor: `${feat.accent}30`,
                  }}
                >
                  {feat.tag}
                </span>
              </div>
              <h4 className="text-[#111111] font-semibold text-sm mb-2" style={{ fontFamily: PD }}>
                {feat.title}
              </h4>
              <p className="text-[#888888] text-xs leading-relaxed">{feat.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
